"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _log = _interopRequireDefault(require("./log.js"));

var _config = _interopRequireDefault(require("./config.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var get = function get() {
  return new Promise(function (resolve, reject) {
    var kcToken = _config["default"].get('kcToken');

    if (typeof window !== 'undefined') {
      window.kc.updateToken().success(function () {
        resolve(window.kc.token);
      }).error(function () {
        _log["default"].error('window.kc failed to updateToken');

        var callback = _config["default"].get('sessionExpiredCallback');

        if (callback) {
          if (_lodash["default"].isFunction(callback)) {
            callback();
          } else {
            console.warn('sessionExpiredCallback is not a function; ignoring');
          }
        }

        reject();
      });
    } else if (kcToken !== undefined) {
      resolve(kcToken);
    } else {
      reject('something is odd here.');
    }
  });
};

var _default = {
  get: get
};
exports["default"] = _default;